"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
/* 1. padding-inline-end = 24px (IconX) + 24px (extra space) */

var Title = exports.Title = (0, _styledComponents["default"])(_index2.Text).attrs({
  forwardedAs: 'h1',
  variant: 'bodyMediumBold'
}).withConfig({
  displayName: "Title",
  componentId: "sc-bugxpe-0"
})(["padding-block-end:", ";padding-inline-end:", ";"], (0, _index.cssSpacing)('tighter-2', '8px'), (0, _index.cssSpacing)('looser-3', '48px'));